// Port names visitors actually type, and the label we show, for ports whose official name changed
// or is spelled several ways. The CODE is the identity: search, lane slugs and the spot-rate engine
// all key on the UN/LOCODE, so an alias only ever changes what can be typed and what is displayed.
//
// Chittagong: Bangladesh renamed it Chattogram (2018). Carriers, rate sources and visitors use both,
// and the spot-rate engine only accepts the code BDCGP (it answers 422 to a name). BDCGM is a second
// code one source uses for the same port; it is deliberately not offered, so the port is not listed twice.

export const PORT_ALIASES: Record<string, string[]> = {
  BDCGP: ['Chattogram', 'Chattagram', 'Chittagong'],
}

export const PORT_LABELS: Record<string, string> = {
  BDCGP: 'Chittagong (Chattogram)',
}

export function portLabel(code: string, name: string, fmt: (s: string) => string): string {
  return PORT_LABELS[code] ?? fmt(name)
}

/** Does the typed text match the port's name, its code, or one of its aliases? */
export function portMatches(code: string, name: string, query: string): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return (
    name.toLowerCase().includes(q) ||
    code.toLowerCase().includes(q) ||
    (PORT_ALIASES[code] ?? []).some((a) => a.toLowerCase().includes(q))
  )
}

/** Names that START with the typed text rank first (typing "Chatt" leads with Chittagong). */
export function portStarts(code: string, name: string, query: string): boolean {
  const q = query.trim().toLowerCase()
  return (
    name.toLowerCase().startsWith(q) ||
    (PORT_ALIASES[code] ?? []).some((a) => a.toLowerCase().startsWith(q))
  )
}
